'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, orderedParticipants) {
  return function (dispatch) {

    var order = orderedParticipants.map(function (p, idx) {
      return { id: p.id, order: idx };
    });

    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      orderedParticipants: orderedParticipants

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/order-participants',
        method: 'POST',
        data: order
      },
      types: ['ORDER_PARTICIPANTS_START', 'ORDER_PARTICIPANTS', 'ORDER_PARTICIPANTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/orderParticipants.js
// module id = 232
// module chunks = 0